<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Contents</span></p>
<p class="centerr"><a href="#/xhtml/part01">PART ONE</a></p>
<p class="centerr"><a href="#/xhtml/chapter01">1</a></p>
<p class="centerr"><a href="#/xhtml/chapter02">2</a></p>
<p class="centerr"><a href="#/xhtml/chapter03">3</a></p>
<p class="centerr"><a href="#/xhtml/chapter04">4</a></p>
<p class="centerr"><span href="#/xhtml/chapter05" title="Link target outside of Sample">5</span></p>
<p class="centerr"><span href="#/xhtml/chapter06" title="Link target outside of Sample">6</span></p>
<p class="centerr"><span href="#/xhtml/chapter07" title="Link target outside of Sample">7</span></p>
<p class="centerr"><span href="#/xhtml/chapter08" title="Link target outside of Sample">8</span></p>
<p class="centerr"><span href="#/xhtml/chapter09" title="Link target outside of Sample">9</span></p>
<p class="centerr"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10</span></p>
<p class="centerr"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11</span></p>
<p class="centerr"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12</span></p>
<p class="centerr"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13</span></p>
<p class="centerr"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14</span></p>
<p class="centerr"><span href="#/xhtml/chapter15" title="Link target outside of Sample">15</span></p>
<p class="centerr" style="margin-top:20px;"><span href="#/xhtml/part02" title="Link target outside of Sample">PART TWO</span></p>
<p class="centerr"><span href="#/xhtml/chapter16" title="Link target outside of Sample">16</span></p>
<p class="centerr"><span href="#/xhtml/chapter17" title="Link target outside of Sample">17</span></p>
<p class="centerr"><span href="#/xhtml/chapter18" title="Link target outside of Sample">18</span></p>
<p class="centerr"><span href="#/xhtml/chapter19" title="Link target outside of Sample">19</span></p>
<p class="centerr"><span href="#/xhtml/chapter20" title="Link target outside of Sample">20</span></p>
<p class="centerr"><span href="#/xhtml/chapter21" title="Link target outside of Sample">21</span></p>
<p class="centerr"><span href="#/xhtml/chapter22" title="Link target outside of Sample">22</span></p>
<p class="centerr"><span href="#/xhtml/chapter23" title="Link target outside of Sample">23</span></p>
<p class="centerr"><span href="#/xhtml/chapter24" title="Link target outside of Sample">24</span></p>
<p class="centerr"><span href="#/xhtml/chapter25" title="Link target outside of Sample">25</span></p>
<p class="centerr"><span href="#/xhtml/chapter26" title="Link target outside of Sample">26</span></p>
<p class="centerr"><span href="#/xhtml/chapter27" title="Link target outside of Sample">27</span></p>
<p class="centerr"><span href="#/xhtml/chapter28" title="Link target outside of Sample">28</span></p>
<p class="centerr"><span href="#/xhtml/chapter29" title="Link target outside of Sample">29</span></p>
<p class="centerr"><span href="#/xhtml/chapter30" title="Link target outside of Sample">30</span></p>
<p class="centerr"><span href="#/xhtml/chapter31" title="Link target outside of Sample">31</span></p>
<p class="centerr"><span href="#/xhtml/chapter32" title="Link target outside of Sample">32</span></p>
<p class="centerr"><span href="#/xhtml/chapter33" title="Link target outside of Sample">33</span></p>
<p class="centerr" style="margin-top:20px;"><span href="#/xhtml/part03" title="Link target outside of Sample">PART THREE</span></p>
<p class="centerr"><span href="#/xhtml/chapter34" title="Link target outside of Sample">34</span></p>
<p class="centerr"><span href="#/xhtml/chapter35" title="Link target outside of Sample">35</span></p>
<p class="centerr"><span href="#/xhtml/chapter36" title="Link target outside of Sample">36</span></p>
<p class="centerr"><span href="#/xhtml/chapter37" title="Link target outside of Sample">37</span></p>
<p class="centerr"><span href="#/xhtml/chapter38" title="Link target outside of Sample">38</span></p>
<p class="centerr"><span href="#/xhtml/chapter39" title="Link target outside of Sample">39</span></p>
<p class="centerr"><span href="#/xhtml/chapter40" title="Link target outside of Sample">40</span></p>
<p class="centerr"><span href="#/xhtml/chapter41" title="Link target outside of Sample">41</span></p>
<p class="centerr"><span href="#/xhtml/chapter42" title="Link target outside of Sample">42</span></p>
<p class="centerr"><span href="#/xhtml/chapter43" title="Link target outside of Sample">43</span></p>
<p class="centerr"><span href="#/xhtml/chapter44" title="Link target outside of Sample">44</span></p>
<p class="centerr"><span href="#/xhtml/chapter45" title="Link target outside of Sample">45</span></p>
<p class="centerr"><span href="#/xhtml/chapter46" title="Link target outside of Sample">46</span></p>
<p class="centerr" style="margin-top:20px;"><span href="#/xhtml/teaser00" title="Link target outside of Sample">Preview: <i>The Skin Palace</i></span></p>
<p class="centerr"><span href="#/xhtml/acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?612aa6ac